import { format } from 'date-fns';
import {
  CapaQuotationChatRoomAnnotationComment,
  CapaQuotationChatRoomSpecificAnnotation,
  CapaQuotationSharedFileAnnotationStatus
} from '@generated/graphql';

export const dummyFiles = [
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  },
  {
    fileSize: 1,
    fileId: '5e445a44-b9b2-4689-8365-6fface8ea91a',
    fileName: 'dummyfiles.step'
  }
];

export const makeMockAnnotation = (
  myName: string,
  myEmail: string
): CapaQuotationChatRoomSpecificAnnotation => {
  const currentDate = new Date();

  return {
    anchorPos: {
      x: 0,
      y: 0,
      z: 0
    },
    annotationId: '1',
    comments: [
      {
        comment:
          '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.',
        createdAt: format(
          currentDate.setHours(currentDate.getHours() - 1),
          'yyyy-MM-dd HH:mm'
        ).replace(' ', 'T'),
        edited: false,
        email: myEmail,
        id: '1',
        isParent: true,
        status: CapaQuotationSharedFileAnnotationStatus.Registered,
        userId: '',
        userName: myName
      },
      {
        comment: '혹시 이부분 수정 가능할까요?',
        createdAt: format(
          currentDate.setMinutes(currentDate.getMinutes() + 14),
          'yyyy-MM-dd HH:mm'
        ).replace(' ', 'T'),
        edited: false,
        email: myEmail,
        id: '2',
        isParent: true,
        status: CapaQuotationSharedFileAnnotationStatus.Registered,
        userId: '',
        userName: myName
      },
      {
        comment: '네 그럼요~ 작업 후 전달 주세요!',
        createdAt: format(
          currentDate.setMinutes(currentDate.getMinutes() + 32),
          'yyyy-MM-dd HH:mm'
        ).replace(' ', 'T'),
        edited: false,
        email: 'partner@capa.ai',
        id: '3',
        isParent: true,
        status: CapaQuotationSharedFileAnnotationStatus.Registered,
        userId: '',
        userName: '정문가'
      },
      {
        comment: '답글로 남겨주셔도 무방합니다.',
        createdAt: format(
          currentDate.setMinutes(currentDate.getMinutes() + 14),
          'yyyy-MM-dd HH:mm'
        ).replace(' ', 'T'),
        edited: false,
        email: 'partner@capa.ai',
        id: '4',
        isParent: true,
        status: CapaQuotationSharedFileAnnotationStatus.Registered,
        userId: '',
        userName: '정문가'
      }
    ],
    commentUsers: [{ userName: '김제조' }],
    createdAt: '2022-08-10',
    handlePos: { x: 0, y: 0, z: 0 },
    isNew: true,
    nodeId: 1,
    status: CapaQuotationSharedFileAnnotationStatus.Registered,
    userId: '1'
  };
};

export const makeMockComments = (
  myName: string
): CapaQuotationChatRoomAnnotationComment[] => {
  const currentDate = new Date();

  return [
    {
      annotationId: '1',
      commentUsers: [{ userName: myName }, { userName: '정문가' }],
      comments: [
        {
          comment:
            '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.',
          createdAt: ''
        },
        {
          comment:
            '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.',
          createdAt: ''
        },
        {
          comment:
            '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.',
          createdAt: ''
        },
        {
          comment:
            '잠시만요 :) 이 부분 내부적으로 논의 후 수정해야 할 것 같습니다.',
          createdAt: ''
        }
      ],
      createdAt: format(currentDate, 'yyyy-MM-dd HH:mm').replace(' ', 'T'),
      fileName: '{도면명}.dwg',
      fileId: '',
      status: CapaQuotationSharedFileAnnotationStatus.Registered,
      userName: myName
    },
    {
      annotationId: '2',
      commentUsers: [{ userName: myName }],
      comments: [
        {
          comment:
            '제가 이쪽은 제조성 검증을 끝마치지 못해서요. 혹시 이부분 진행하고 다시 말씀드려도 될까요?',
          createdAt: '',
          userName: myName
        }
      ],
      createdAt: format(
        currentDate.setMinutes(currentDate.getMinutes() - 4),
        'yyyy-MM-dd HH:mm'
      ).replace(' ', 'T'),
      fileName: '{도면명}.dwg',
      fileId: '',
      status: CapaQuotationSharedFileAnnotationStatus.Registered,
      userName: myName
    },
    {
      annotationId: '3',
      commentUsers: [{ userName: '정문가' }],
      comments: [
        {
          comment:
            '이부분은 구현이 좀 어려울 수도 있을 것 같습니다. 확인 후 알려주세요~',
          createdAt: '',
          userName: '정문가'
        }
      ],
      createdAt: format(
        currentDate.setMinutes(currentDate.getMinutes() - 42),
        'yyyy-MM-dd HH:mm'
      ).replace(' ', 'T'),
      fileName: '{도면명}.dwg',
      fileId: '',
      status: CapaQuotationSharedFileAnnotationStatus.Registered,
      userName: '정문가'
    },
    {
      annotationId: '4',
      commentUsers: [{ userName: '정문가' }],
      comments: [
        {
          comment: '이부분은 재료 수정이 조금 필요할 수도 있을 것 같아요!',
          createdAt: '',
          userName: '정문가'
        }
      ],
      createdAt: format(
        currentDate.setMinutes(currentDate.getMinutes() - 14),
        'yyyy-MM-dd HH:mm'
      ).replace(' ', 'T'),
      fileName: '{도면명}.dwg',
      fileId: '',
      status: CapaQuotationSharedFileAnnotationStatus.Registered,
      userName: '정문가'
    }
  ];
};
